// @flow

import React from 'react';
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
} from 'reactstrap';
import './planneddowntime.scss';

export default class PlannedDowntimeModal extends React.Component {
  props: Props;

  constructor() {
    super();
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.stopPropagation = this.stopPropagation.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleCloseModal);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleCloseModal);
  }

  handleCloseModal() {
    const { closePlannedDowntimeModal } = this.props;
    closePlannedDowntimeModal();
  }

  stopPropagation(event) {
    event.nativeEvent.stopImmediatePropagation();
  }

  render() {
    const { plannedDowntimeModalIsOpen } = this.props;
    return (
      <Modal isOpen={plannedDowntimeModalIsOpen} onClick={this.stopPropagation} className="modal-dialog-centered planned-downtime-modal">
        <div className="modal-icon-holder">
          <span className="prs-icon prs-icon-info" />
        </div>
        <button type="button" className="close" onClick={this.handleCloseModal} aria-label="Close">
          <svg width="17px" height="17px" className="inner-icon" viewBox="0 0 21 21" version="1.1">
            <title>Cross</title>
            <path d="M0,1 L19,20 L20,18 L2,0 L0,2 Z" fill="#071c64" />
            <path d="M19,0 L0,19 L2,20 L20,2 L18,0 Z" fill="#071c64" />
          </svg>
        </button>
        <ModalHeader>
          Planned downtime
        </ModalHeader>
        <ModalBody>
          <p>
            {'Due to essential maintenance this application will be '}
            {'unavailable between 16:00 Tuesday 18th December and 11:00 '}
            {'on Wednesday 19th December 2018.'}
          </p>
          <p>
            Please accept our apologies for any inconvenience caused.
          </p>
        </ModalBody>
        <hr />
        <ModalFooter>
          <button
            type="button"
            className="btn-prs btn-outline-dark btn-block"
            onClick={() => this.handleCloseModal()}
          >
            Close
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}
